import { Box, Typography } from "@mui/material";
import EventList from "../../components/coachingNavigator/coachingCalendar/EventList";
import { withApplicationInsights } from "../../components/telemetry";

const CoachingCalendar = () => {
  return (
    <Box
      sx={{ backgroundColor: "#FFFFFF", minHeight: "calc(100vh - 64px)" }}
    >
      <EventList />
    </Box>
  );
};

export default withApplicationInsights(CoachingCalendar, "CoachingCalendar");
